import React from 'react';
import { FormattedMessage } from 'react-intl';
import ExperianCreditRatingRow from './ExperianCreditRatingRow';
import { EXPERIAN_ERROR } from './../../../../../constants';
import utils from './../../../../../utils/utilities';
import { isEqual } from 'lodash';
import api from '../../Dashboard.api';

class ExperianCreditRatingPod extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            allEntitiesWithExperian: null
        };

        this.getFilterMessageId = this.getFilterMessageId.bind(this);
        this.setExperianPodEntities = this.setExperianPodEntities.bind(this);
    }

    componentWillMount() {
        this.loadData(this.props.days, this.props.entities, this.props.pestle, this.props.risk, this.props.language);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.days !== nextProps.days ||
            !isEqual(this.props.pestle, nextProps.pestle) ||
            !isEqual(this.props.risk, nextProps.risk) ||
            !isEqual(this.props.entities, nextProps.entities)) {
            this.loadData(nextProps.days, nextProps.entities, nextProps.pestle, nextProps.risk, nextProps.language);
        }
    }

    loadData(days, entities, pestle, risk, language) {
        let catFilter = utils.buildDashboardFilter(entities, risk, pestle, days ,language);

        return api.getEntitiesWithExperian(catFilter)
            .then((companies) => {

                this.setExperianPodEntities(companies);
            })
            .catch((error) => {
                utils.logError(error, 'ExperianCreditRatingPod.loadData():');
                this.setExperianPodEntities(EXPERIAN_ERROR);
            });
    }

    setExperianPodEntities(allEntitiesWithExperian) {
        this.setState({
            allEntitiesWithExperian: allEntitiesWithExperian
        })
    }

    getFilterMessageId() {
        switch (this.props.days.toString()) {
            case '1':
                return 'Dashboard_Charts_UIText_dashboard.experianRatingPod.filter1Day';
            case '7':
                return 'Dashboard_Charts_UIText_dashboard.experianRatingPod.filter7Days';
            default:
                return 'Dashboard_Charts_UIText_dashboard.experianRatingPod.filter30Days';
        }
    };

    render() {

        if (this.state.allEntitiesWithExperian === EXPERIAN_ERROR) {
            return <div className="dashboard-page__trending--experian-credit-rating">
                <div className="experian-title">
                    <FormattedMessage id={this.getFilterMessageId()} />
                </div>
                <div className='error-message'><FormattedMessage id='Entities_Dossier_UIText_dossierServiceUnavailable'/></div>
            </div>;
        }

        let filteredExperianEntities = [];
        if (this.state.allEntitiesWithExperian) {
            filteredExperianEntities = this.state.allEntitiesWithExperian.filter(entity => entity.uiExperianDocument);
            filteredExperianEntities = utils.sortArrayByKey(filteredExperianEntities, 'title');
        }

        return (

            <div className="dashboard-page__trending--experian-credit-rating">

                <div className="experian-title">
                    <FormattedMessage id={this.getFilterMessageId()} />
                </div>

                {!this.state.allEntitiesWithExperian ? <div className="inline-spinner"></div> :
                    <div className="entities-body">
                        <table>
                            <thead>
                                <tr>
                                    <th className="entity-title"><FormattedMessage
                                        id="Dashboard_Charts_UIText_dashboard.entity" /></th>
                                    <th><FormattedMessage
                                        id='Dashboard_CoreFunctionality_UIText_experian.delinquencyRisk' /></th>
                                    <th><FormattedMessage
                                        id='Dashboard_CoreFunctionality_UIText_experian.stabilityRisk' /></th>
                                    <th><FormattedMessage
                                        id='Dashboard_CoreFunctionality_UIText_experian.bankruptcyFiled' /></th>
                                </tr>
                            </thead>

                            <tbody>
                                {
                                    filteredExperianEntities.length !== 0 ?
                                        filteredExperianEntities.map(allEntitiesWithExperian =>
                                            <ExperianCreditRatingRow key={allEntitiesWithExperian.id}
                                                                     entityId={allEntitiesWithExperian.id}
                                                                     entityTitle={allEntitiesWithExperian.title}
                                                                     experianId={allEntitiesWithExperian.experianBusinessId}
                                                                     uiExperianDocument={allEntitiesWithExperian.uiExperianDocument} />
                                        ) :
                                        <tr className="empty-experian-credit-rating">
                                            <td colSpan="8">
                                                <FormattedMessage
                                                    id="General_CoreFunctionality_UIText_general.nothingToDisplay" />
                                            </td>
                                        </tr>
                                }

                            </tbody>
                        </table>

                    </div>

                }

            </div>
        );
    }

}

export default ExperianCreditRatingPod;


// WEBPACK FOOTER //
// ./src/scripts/pages/StartPage/Dashboard/components/ExperianCreditRatingPod/ExperianCreditRatingPod.jsx